import React, { useCallback, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PerformanceNavbar } from "./reusedcomponent/navbar";
import { useDispatch, useSelector } from "react-redux";
import { employeeMngtThunk } from "../../../store/actions/employeemanagement/employee.thunk";
import { constant } from "../../../Constants/constant";

export const EmployeeHistoryReview = () => {
  const { employees } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();

  console.log("employee", employees);

  const getEmployess = useCallback(async () => {
    await dispatch(employeeMngtThunk.getEmployeesDetails());
  }, [dispatch]);

  useEffect(() => {
    getEmployess();
  }, []);
  return (
    <React.Fragment>
      <PerformanceNavbar />
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="m-t-30 m-b-30">
                <div className="row">
                  <div className="text-center">
                    <h3 className="text-dark">EMPLOYEES</h3>
                  </div>
                  <div className="col-md-12 card m-2 shadow p-2">
                    <table className="table table-bordered shadow">
                      <thead>
                        <tr>
                          <th className="th-sm">NO</th>
                          <th className="th-sm">USER</th>
                          <th className="th-sm">NAME </th>
                          <th className="th-sm">ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        {employees.map((employee, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>
                              <img
                                width="60px"
                                src={`${
                                  employee.profile_picture
                                    ? `${constant.ImgURL}/uploads/${employee.profile_picture}`
                                    : "/img/Needle_logo.png"
                                }`}
                                className="rounded-circle img-thumbnail"
                                alt="profile"
                              />
                            </td>
                            <td>
                              {employee.first_name.toUpperCase()}{" "}
                              {employee.last_name.toUpperCase()}
                            </td>{" "}
                            <td>
                              <Link to="/dashboard/performance/history-review">
                                <button className="btn btn-block nt-button-color-default">
                                  View History
                                </button>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/perfomancemanagement/employee_review_history.js